
// import React, { useState, useEffect, useMemo } from "react";
// import { MagnifyingGlassIcon, ChevronRightIcon, InboxIcon } from "@heroicons/react/20/solid";
// import * as XLSX from "xlsx";

// const API_BASE = process.env.REACT_APP_API;
// const fmt = (n) => (n == null ? "0" : Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 }));

// const COLS = [
//     { key: "Tender_No",     label: "No",              align: "left" },
//     { key: "Tender_Date",   label: "Date",            align: "left" },
//     { key: "System_Name_E", label: "Item",            align: "left" },
//     { key: "DO",            label: "DO / Payment To", align: "left",  cls: "text-[11px] text-blue-700" },
//     { key: "season",        label: "Season",          align: "center" },
//     { key: "Mill_Rate",     label: "Mill Rate",       align: "right", render: v => `₹${fmt(v)}`, cls: "font-mono text-amber-700" },
//     { key: "Purc_Rate",     label: "Purc Rate",       align: "right", render: v => `₹${fmt(v)}`, cls: "font-mono text-emerald-700 font-medium" },
//     { key: "Quantal",       label: "Qty (Qntl)",      align: "right", cls: "font-mono font-medium text-slate-800" },
// ];

// // ── Print helper ─────────────────────────────────────────────────────────────
// function triggerPrint(groupedData, grandTotal, totalRecords, selectedDate) {
//     const win = window.open("", "_blank", "width=1200,height=800");
//     if (!win) { alert("Please allow pop-ups for this page to use Print."); return; }

//     function buildTableRows(items) {
//         return items.map((row, i) => `
//             <tr style="border-bottom:1px solid #f1f5f9">
//                 <td style="padding:7px 10px;font-size:11px;color:#94a3b8;text-align:center">${i + 1}</td>
//                 <td style="padding:7px 10px;font-size:12px;color:#475569">${row.Tender_No ?? "—"}</td>
//                 <td style="padding:7px 10px;font-size:12px;color:#475569">${row.Tender_Date ?? "—"}</td>
//                 <td style="padding:7px 10px;font-size:12px;color:#475569">${row.System_Name_E ?? "—"}</td>
//                 <td style="padding:7px 10px;font-size:12px;color:#1d4ed8;font-weight:500">${row.DO ?? "—"}</td>
//                 <td style="padding:7px 10px;font-size:12px;color:#475569;text-align:center">${row.season ?? "—"}</td>
//                 <td style="padding:7px 10px;font-size:12px;color:#b45309;text-align:right;font-family:monospace">₹${fmt(row.Mill_Rate)}</td>
//                 <td style="padding:7px 10px;font-size:12px;color:#047857;font-weight:500;text-align:right;font-family:monospace">₹${fmt(row.Purc_Rate)}</td>
//                 <td style="padding:7px 10px;font-size:12px;color:#1e293b;text-align:right;font-family:monospace;font-weight:500">${fmt(row.Quantal)}</td>
//             </tr>
//         `).join("");
//     }

//     function buildMillBlock(mill) {
//         const gradeBlocks = Array.from(mill.grades.values()).map(grade => `
//             <div style="margin:0 16px 16px;border:1px solid #e2e8f0;border-radius:8px;overflow:hidden">
//                 <div style="background:#eff6ff;padding:8px 14px;display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid #bfdbfe">
//                     <span style="font-size:11px;font-weight:600;color:#1e40af;text-transform:uppercase;letter-spacing:.05em">
//                         Grade: <strong style="color:#1e3a8a">${grade.name}</strong>
//                     </span>
//                     <span style="font-size:11px;font-weight:600;background:#dbeafe;color:#1e40af;padding:2px 10px;border-radius:6px">${fmt(grade.sub)} Qntl</span>
//                 </div>
//                 <table style="width:100%;border-collapse:collapse;table-layout:fixed">
//                     <colgroup>
//                         <col style="width:36px"><col style="width:8%"><col style="width:10%"><col style="width:12%">
//                         <col style="width:18%"><col style="width:9%"><col style="width:10%"><col style="width:10%"><col style="width:10%">
//                     </colgroup>
//                     <thead>
//                         <tr style="background:#f8fafc;border-bottom:1px solid #e2e8f0">
//                             <th style="padding:7px 10px;font-size:10px;font-weight:600;color:#94a3b8;text-align:center">#</th>
//                             <th style="padding:7px 10px;font-size:10px;font-weight:600;color:#94a3b8;text-align:left">Tender No</th>
//                             <th style="padding:7px 10px;font-size:10px;font-weight:600;color:#94a3b8;text-align:left">Date</th>
//                             <th style="padding:7px 10px;font-size:10px;font-weight:600;color:#94a3b8;text-align:left">Item</th>
//                             <th style="padding:7px 10px;font-size:10px;font-weight:600;color:#94a3b8;text-align:left">DO / Payment To</th>
//                             <th style="padding:7px 10px;font-size:10px;font-weight:600;color:#94a3b8;text-align:center">Season</th>
//                             <th style="padding:7px 10px;font-size:10px;font-weight:600;color:#94a3b8;text-align:right">Mill Rate</th>
//                             <th style="padding:7px 10px;font-size:10px;font-weight:600;color:#94a3b8;text-align:right">Purc Rate</th>
//                             <th style="padding:7px 10px;font-size:10px;font-weight:600;color:#94a3b8;text-align:right">Qty (Qntl)</th>
//                         </tr>
//                     </thead>
//                     <tbody>${buildTableRows(grade.items)}</tbody>
//                 </table>
//             </div>
//         `).join("");

//         return `
//         <div style="background:#fff;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;margin-bottom:16px;page-break-inside:avoid">
//             <div style="background:#0c447c;padding:10px 16px;display:flex;justify-content:space-between;align-items:center">
//                 <span style="font-size:13px;font-weight:600;color:#e0f2fe">${mill.name}</span>
//                 <div style="text-align:right">
//                     <div style="font-size:9px;color:#93c5fd;text-transform:uppercase;letter-spacing:.06em">Total Qntl</div>
//                     <div style="font-size:13px;font-family:monospace;font-weight:600;color:#bfdbfe">${fmt(mill.total)} Qntl</div>
//                 </div>
//             </div>
//             <div style="padding-top:14px">${gradeBlocks}</div>
//         </div>`;
//     }

//     win.document.write(`<!DOCTYPE html>
// <html><head><meta charset="UTF-8"/>
// <title>Daily Purchase Report — ${selectedDate}</title>
// <style>
//     *{box-sizing:border-box;margin:0;padding:0}
//     body{font-family:Arial,sans-serif;background:#f1f5f9;padding:20px;color:#1e293b}
//     @page{margin:12mm 10mm;size:A4 landscape}
//     @media print{body{background:#fff;padding:0}.no-print{display:none!important}}
// </style></head><body>
// <div class="no-print" style="text-align:right;margin-bottom:16px">
//     <button onclick="window.print()" style="background:#0c447c;color:#fff;border:none;padding:8px 20px;border-radius:8px;font-size:13px;cursor:pointer;font-weight:600">
//         Print / Save as PDF
//     </button>
// </div>
// <div style="background:#0c447c;border-radius:12px;padding:14px 20px;display:flex;justify-content:space-between;align-items:center;margin-bottom:18px">
//     <div>
//         <div style="font-size:10px;color:#93c5fd;text-transform:uppercase;letter-spacing:.08em">Daily Purchase Report</div>
//         <div style="font-size:14px;font-weight:600;color:#e0f2fe;margin-top:2px">${selectedDate} &nbsp;·&nbsp; ${groupedData.length} Mills &nbsp;·&nbsp; ${totalRecords} Records</div>
//     </div>
//     <div style="text-align:right">
//         <div style="font-size:9px;color:#93c5fd;text-transform:uppercase;letter-spacing:.06em">Grand Total Qntl</div>
//         <div style="font-size:20px;font-family:monospace;font-weight:700;color:#bfdbfe">${fmt(grandTotal)} <span style="font-size:12px">Qntl</span></div>
//     </div>
// </div>
// ${groupedData.map(buildMillBlock).join("")}
// </body></html>`);
//     win.document.close();
//     setTimeout(() => win.print(), 600);
// }

// // ── Component ─────────────────────────────────────────────────────────────────
// // toDate comes from parent ClosingStock — no internal date picker
// export default function DailyPurchaseReport({ toDate }) {
//     const [rows, setRows] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [search, setSearch] = useState("");
//     const [expandedMills, setExpandedMills] = useState(new Set());

//     const companyCode = sessionStorage.getItem("Company_Code");
//     const yearCode    = sessionStorage.getItem("Year_Code");

//     // Re-fetch whenever the parent changes the date
//     useEffect(() => {
//         if (!toDate || !companyCode) return;
//         fetchData();
//     }, [toDate, companyCode]);

//     async function fetchData() {
//         setLoading(true);
//         try {
//             // ✅ Fixed: use the actual toDate variable (was incorrectly "toDate" string before)
//             const res = await fetch(
//                 `${API_BASE}/dailypurchase-report?Company_Code=${companyCode}&Selected_Date=${toDate}`
//             );
//             const data = await res.json();
//             const allRows = data.get_allTenders || [];
//             setRows(allRows);
//             setExpandedMills(new Set(allRows.map(r => r.Mill_Name || "Unknown Mill")));
//         } catch (e) {
//             console.error(e);
//         } finally {
//             setLoading(false);
//         }
//     }

//     const groupedData = useMemo(() => {
//         const q = search.toLowerCase();
//         const filtered = q
//             ? rows.filter(r => Object.values(r).some(v => String(v ?? "").toLowerCase().includes(q)))
//             : rows;

//         const mills = new Map();
//         filtered.forEach(row => {
//             const m = row.Mill_Name || "Unknown Mill";
//             const g = row.Grade || "—";
//             if (!mills.has(m)) mills.set(m, { name: m, grades: new Map(), total: 0 });
//             const mg = mills.get(m);
//             if (!mg.grades.has(g)) mg.grades.set(g, { name: g, items: [], sub: 0 });
//             const gg = mg.grades.get(g);
//             gg.items.push(row);
//             gg.sub  += Number(row.Quantal || 0);
//             mg.total += Number(row.Quantal || 0);
//         });
//         return Array.from(mills.values()).sort((a, b) => a.name.localeCompare(b.name));
//     }, [rows, search]);

//     const totalRecords = groupedData.reduce((s, mg) => s + Array.from(mg.grades.values()).reduce((a, g) => a + g.items.length, 0), 0);
//     const grandTotal   = groupedData.reduce((s, mg) => s + mg.total, 0);

//     function toggleMill(name) {
//         const next = new Set(expandedMills);
//         next.has(name) ? next.delete(name) : next.add(name);
//         setExpandedMills(next);
//     }

//     function handleExportExcel() {
//         const sheetData = [];
//         sheetData.push([`Daily Purchase Report — ${toDate}`]);
//         sheetData.push([`Grand Total: ${fmt(grandTotal)} Qntl`, `Records: ${totalRecords}`, `Mills: ${groupedData.length}`]);
//         sheetData.push([]);

//         groupedData.forEach(mill => {
//             sheetData.push([`Mill: ${mill.name}`, `Total: ${fmt(mill.total)} Qntl`]);
//             sheetData.push([]);
//             Array.from(mill.grades.values()).forEach(grade => {
//                 sheetData.push([`  Grade: ${grade.name}`, `Grade Total: ${fmt(grade.sub)} Qt`]);
//                 sheetData.push(["#", "Tender No", "Tender Date", "Item", "DO / Payment To", "Season", "Mill Rate (₹)", "Purc Rate (₹)", "Qty (Qntl)"]);
//                 grade.items.forEach((row, idx) => {
//                     sheetData.push([
//                         idx + 1,
//                         row.Tender_No ?? "—",
//                         row.Tender_Date ?? "—",
//                         row.System_Name_E ?? "—",
//                         row.DO ?? "—",
//                         row.season ?? "—",
//                         Number(row.Mill_Rate || 0),
//                         Number(row.Purc_Rate || 0),
//                         Number(row.Quantal || 0),
//                     ]);
//                 });
//                 sheetData.push([]);
//             });
//             sheetData.push([]);
//         });

//         const wb = XLSX.utils.book_new();
//         const ws = XLSX.utils.aoa_to_sheet(sheetData);
//         ws["!cols"] = [{ wch: 8 }, { wch: 15 }, { wch: 15 }, { wch: 20 }, { wch: 25 }, { wch: 10 }, { wch: 14 }, { wch: 14 }, { wch: 12 }];
//         XLSX.utils.book_append_sheet(wb, ws, "Purchase Report");
//         XLSX.writeFile(wb, `Purchase_Report_${toDate}.xlsx`);
//     }

//     return (
//         <div className="flex flex-col h-screen bg-slate-100 antialiased">
//             <style>{`
//                 @media print {
//                     body * { visibility: hidden !important; }
//                     #print-area, #print-area * { visibility: visible !important; }
//                     #print-area { position: absolute; top: 0; left: 0; width: 100%; }
//                     .no-print { display: none !important; }
//                 }
//             `}</style>

//             {/* ── TOP BAR (no date picker — date comes from parent) ── */}
//             <div className="no-print bg-white border-b border-slate-200 px-5 py-3 flex items-center justify-between gap-3 sticky top-0 z-50">

//                 {/* Left: title + active date pill */}
//                 <div className="flex items-center gap-3 shrink-0">
//                     <div>
//                         <p className="text-[15px] font-medium text-slate-900 leading-tight">Daily Purchase</p>
//                         <p className="text-[10px] text-slate-400 uppercase tracking-widest">Inventory Report</p>
//                     </div>
//                     {toDate && (
//                         <>
//                             <div className="w-px h-7 bg-slate-200" />
//                             <span className="flex items-center gap-1.5 px-3 py-1 rounded-full bg-blue-50 border border-blue-200 text-[11px] font-semibold text-blue-700">
//                                 <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />
//                                 {new Date(toDate).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
//                             </span>
//                         </>
//                     )}
//                 </div>

//                 {/* Center: search */}
//                 <div className="flex-1 flex justify-center">
//                     <label className="flex items-center gap-2 border border-slate-200 rounded-lg px-4 py-1.5 bg-slate-50 w-80">
//                         <MagnifyingGlassIcon className="w-4 h-4 text-slate-400 shrink-0" />
//                         <input
//                             value={search}
//                             onChange={e => setSearch(e.target.value)}
//                             placeholder="Search mill, grade, DO, item..."
//                             className="text-[13px] bg-transparent outline-none w-full text-slate-700 placeholder:text-slate-400"
//                         />
//                     </label>
//                 </div>

//                 {/* Right: summary + actions */}
//                 <div className="flex items-center gap-3 shrink-0">
//                     {!loading && rows.length > 0 && (
//                         <div className="flex items-center gap-3 text-[11px] text-slate-500">
//                             <span><b className="text-slate-700">{groupedData.length}</b> Mills</span>
//                             <span><b className="text-slate-700">{totalRecords}</b> Records</span>
//                             <span className="font-mono font-bold text-blue-700">{fmt(grandTotal)} Qntl</span>
//                         </div>
//                     )}
//                     <div className="w-px h-6 bg-slate-200" />
//                     <button
//                         onClick={handleExportExcel}
//                         disabled={loading || rows.length === 0}
//                         className="flex items-center gap-1.5 px-3 py-1.5 text-[12px] font-medium border border-emerald-300 text-emerald-700 rounded-lg bg-emerald-50 hover:bg-emerald-100 transition-colors disabled:opacity-40"
//                     >
//                         <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
//                         </svg>
//                         Export
//                     </button>
//                     <button
//                         onClick={() => triggerPrint(groupedData, grandTotal, totalRecords, toDate)}
//                         disabled={loading || rows.length === 0}
//                         className="flex items-center gap-1.5 px-3 py-1.5 text-[12px] font-medium border border-slate-300 text-slate-700 rounded-lg bg-white hover:bg-slate-50 transition-colors disabled:opacity-40"
//                     >
//                         <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.056 48.056 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z" />
//                         </svg>
//                         Print
//                     </button>
//                 </div>
//             </div>

//             {/* ── MAIN CONTENT ── */}
//             <div id="print-area" className="flex-1 overflow-auto p-4 flex flex-col gap-3">
//                 {loading ? (
//                     <div className="flex justify-center items-center h-48 text-slate-400 text-sm animate-pulse">
//                         Fetching records…
//                     </div>
//                 ) : groupedData.length === 0 ? (
//                     <div className="flex flex-col items-center justify-center h-48 gap-2 border-2 border-dashed border-slate-200 rounded-2xl text-slate-400 text-sm bg-white">
//                         <InboxIcon className="w-8 h-8 opacity-25" />
//                         No records found for this date.
//                     </div>
//                 ) : groupedData.map(mg => (
//                     <div key={mg.name} className="bg-white rounded-xl border border-slate-200 overflow-hidden">

//                         {/* Mill header */}
//                         <div
//                             onClick={() => toggleMill(mg.name)}
//                             className="flex items-center justify-between px-4 py-2.5 bg-[#0C447C] cursor-pointer hover:bg-[#185FA5] transition-colors no-print"
//                         >
//                             <div className="flex items-center gap-2">
//                                 <ChevronRightIcon className={`w-[14px] h-[14px] text-blue-300 transition-transform duration-200 shrink-0 ${expandedMills.has(mg.name) ? "rotate-90" : ""}`} />
//                                 <span className="text-[13px] font-medium text-blue-50">{mg.name}</span>
//                                 <span className="text-[10px] text-blue-400 ml-1">
//                                     {Array.from(mg.grades.values()).reduce((a, g) => a + g.items.length, 0)} records
//                                 </span>
//                             </div>
//                             <div className="flex items-center gap-2">
//                                 <span className="text-[10px] text-blue-400 uppercase tracking-wide">Mill total</span>
//                                 <span className="font-mono text-[13px] font-medium text-blue-200 bg-white/10 px-3 py-0.5 rounded-md">
//                                     {fmt(mg.total)} Qntl
//                                 </span>
//                             </div>
//                         </div>

//                         {/* Grade sections */}
//                         {expandedMills.has(mg.name) && Array.from(mg.grades.values()).map(gg => (
//                             <div key={gg.name} className="border-t border-slate-100">
//                                 <div className="flex items-center justify-between px-4 py-2 bg-blue-50 border-b border-blue-100">
//                                     <span className="text-[10px] font-medium text-blue-600 uppercase tracking-wide">
//                                         Grade &nbsp;<strong className="text-blue-900">{gg.name}</strong>
//                                     </span>
//                                     <span className="text-[10px] font-medium bg-blue-200 text-blue-900 px-3 py-0.5 rounded-md">
//                                         Grade total: {fmt(gg.sub)} Qntl
//                                     </span>
//                                 </div>
//                                 <div className="overflow-x-auto">
//                                     <table className="w-full border-collapse" style={{ tableLayout: "fixed" }}>
//                                         <colgroup>
//                                             <col style={{ width: 36 }} />
//                                             <col style={{ width: "8%" }} /><col style={{ width: "10%" }} />
//                                             <col style={{ width: "12%" }} /><col style={{ width: "18%" }} />
//                                             <col style={{ width: "9%" }} /><col style={{ width: "10%" }} />
//                                             <col style={{ width: "10%" }} /><col style={{ width: "10%" }} />
//                                         </colgroup>
//                                         <thead>
//                                             <tr className="border-b border-slate-100 bg-slate-50">
//                                                 <th className="px-3 py-2 text-[10px] font-medium text-slate-400 uppercase text-center">#</th>
//                                                 {COLS.map(col => (
//                                                     <th key={col.key} className={`px-3 py-2 text-[10px] font-medium text-slate-400 uppercase tracking-wide text-${col.align}`}>
//                                                         {col.label}
//                                                     </th>
//                                                 ))}
//                                             </tr>
//                                         </thead>
//                                         <tbody className="divide-y divide-slate-50">
//                                             {gg.items.map((row, idx) => (
//                                                 <tr key={idx} className="hover:bg-slate-50 transition-colors">
//                                                     <td className="px-3 py-2 text-[10px] text-slate-300 text-center">{idx + 1}</td>
//                                                     {COLS.map(col => (
//                                                         <td key={col.key} className={`px-3 py-2 text-[12px] text-${col.align} ${col.cls || "text-slate-600"}`}>
//                                                             <span className="block truncate">
//                                                                 {col.render ? col.render(row[col.key], row) : (row[col.key] ?? "—")}
//                                                             </span>
//                                                         </td>
//                                                     ))}
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// }

























// import React, { useState, useEffect, useMemo } from "react";
// import axios from "axios";

// const API_BASE = process.env.REACT_APP_API;

// const fmt = (n) => {
//   const num = parseFloat(n);
//   if (isNaN(num)) return "0.00";
//   // Formatting to 2 decimal places with Indian numbering system
//   return num.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
// };

// const groupData = (rows) => {
//   const mills = new Map();
//   rows.forEach((r) => {
//     const code = r.Mill_Code ?? "?";
//     if (!mills.has(code)) {
//       mills.set(code, { 
//         code, 
//         name: r.Short_Name || code, 
//         rows: [], 
//         totalQty: 0, 
//         totalLot: 0, 
//         totalSold: 0 
//       });
//     }
//     const m = mills.get(code);
//     m.rows.push(r);
//     m.totalQty += Number(r.PurcQntl ?? r.Quantal ?? 0);
//     m.totalLot += Number(r.LotSize ?? 0);
//     m.totalSold += Number(r.Sold ?? 0);
//   });
//   return Array.from(mills.values()).sort((a, b) => a.name.localeCompare(b.name));
// };

// // --- Styles ---
// const TH_STYLE = { 
//   padding: "8px 10px", 
//   fontSize: "13px", 
//   color: "#475569", 
//   textAlign: "left", 
//   borderBottom: "2px solid #cbd5e1", 
//   fontWeight: "800",
//   textTransform: "uppercase",
//   backgroundColor: "#f8fafc"
// };

// const TD_STYLE = { 
//   padding: "8px 10px", 
//   fontSize: "14px", 
//   borderBottom: "1px solid #e2e8f0", 
//   fontWeight: "600", // Bolder text for readability
//   color: "#1e293b"
// };

// const MillCard = ({ mill, type }) => (
//   <div style={{
//     background: "#fff",
//     marginBottom: "8px", 
//     border: "2px solid #cbd5e1",
//     boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//     borderRadius: "4px"
//   }}>
//     {/* Mill Name Bar */}
//     <div style={{ 
//       background: type === "purchase" ? "#dbeafe" : "#dcfce7", 
//       padding: "10px 15px", 
//       display: "flex", 
//       justifyContent: "space-between", 
//       borderBottom: "2px solid #cbd5e1" 
//     }}>
//       <span style={{ fontWeight: "900", fontSize: "16px", color: "#0f172a" }}>{mill.name}</span>
//       <span style={{ fontSize: "14px", fontWeight: "900", color: "#1e293b" }}>
//         {type === "purchase" 
//           ? `Total: ${fmt(mill.totalQty)} Qntl` 
//           : `Sold: ${fmt(mill.totalSold)} Qntl`}
//       </span>
   
//     </div>

//     <table style={{ width: "100%", borderCollapse: "collapse" }}>
//       <thead>
//         <tr>
//           <th style={{...TH_STYLE,textAlign: "left"}}>Grade</th>
//           <th style={{...TH_STYLE,textAlign: "left"}}>DO No</th>
//           <th style={{...TH_STYLE,textAlign: "left"}}>Season</th>
//           <th style={{ ...TH_STYLE, textAlign: "right" }}>Mill Rate</th>
//           <th style={{ ...TH_STYLE, textAlign: "right" }}>Purchase Rate</th>
//           {type === "purchase" ? (
//             <th style={{ ...TH_STYLE, textAlign: "right" }}>Quantity (Qntl)</th>
//           ) : (
//             <>
//               <th style={{ ...TH_STYLE, textAlign: "right" }}>Lot (Qntl)</th>
//               <th style={{ ...TH_STYLE, textAlign: "right" }}>Sold (Qntl)</th>
//             </>
//           )}
//         </tr>
//       </thead>
//       <tbody>
//         {mill.rows.map((r, i) => (
//           <tr key={i}>
//             <td style={{ ...TD_STYLE, textAlign: "left", fontFamily: "monospace" }}>{r.Grade || "—"}</td>
//             <td style={{ ...TD_STYLE, textAlign: "left", fontFamily: "monospace" }}>{r.do || "—"}</td>
//             <td style={{ ...TD_STYLE, textAlign: "left", fontFamily: "monospace" }}>{r.season || "—"}</td>
//             <td style={{ ...TD_STYLE, textAlign: "right", fontFamily: "monospace" }}>{fmt(r.Mill_Rate)}</td>
//             <td style={{ ...TD_STYLE, textAlign: "right", fontFamily: "monospace" }}>{fmt(r.Purc_Rate)}</td>
//             {type === "purchase" ? (
//               <td style={{ ...TD_STYLE, textAlign: "right", color: "#2563eb" }}>{fmt(r.PurcQntl || r.Quantal)}</td>
//             ) : (
//               <>
//                 <td style={{ ...TD_STYLE, textAlign: "right", color: "#64748b" }}>{fmt(r.LotSize)}</td>
//                 <td style={{ ...TD_STYLE, textAlign: "right", color: "#059669" }}>{fmt(r.Sold)}</td>
//               </>
//             )}
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// export default function EnhancedReport({ toDate }) {
//   const [data, setData] = useState({ pRows: [], sRows: [] });
//   const [loading, setLoading] = useState(false);
//   const companyCode = sessionStorage.getItem("Company_Code");

//   useEffect(() => {
//     if (!toDate || !companyCode) return;
//     setLoading(true);
//     Promise.all([
//       axios.get(`${API_BASE}/dailypurchase-report`, { params: { Company_Code: companyCode, Selected_Date: toDate } }),
//       axios.get(`${API_BASE}/getallsauda`, { params: { Company_Code: companyCode, Selected_Date: toDate } }),
//     ]).then(([p, s]) => {
//       setData({ pRows: p.data.get_allTenders || [], sRows: s.data.get_live_tenders || [] });
//       setLoading(false);
//     }).catch(() => setLoading(false));
//   }, [toDate, companyCode]);

//   const pMills = useMemo(() => groupData(data.pRows), [data.pRows]);
//   const sMills = useMemo(() => groupData(data.sRows), [data.sRows]);

//   const grandPurch = pMills.reduce((acc, m) => acc + m.totalQty, 0);
//   const grandSold = sMills.reduce((acc, m) => acc + m.totalSold, 0);
//   const grandLot = sMills.reduce((acc, m) => acc + m.totalLot, 0);

//   if (loading) return <div style={{ padding: "40px", fontSize: "20px", fontWeight: "bold" }}>Loading Report Data...</div>;

//   return (
//     <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: "#cbd5e1" }}>
      
//       {/* Side-by-Side Columns */}
//       <div style={{ display: "flex", flex: 1, gap: "5px", overflow: "hidden", padding: "5px" }}>
        
//         {/* LEFT COLUMN: PURCHASE */}
//         <div style={{ flex: 1, display: "flex", flexDirection: "column", background: "#f1f5f9", borderRadius: "8px" }}>
//           <div style={{ background: "#1e3a8a", color: "#fff", padding: "15px", borderRadius: "8px 8px 0 0" }}>
//             <div style={{ fontSize: "14px", fontWeight: "700", opacity: 0.9 }}>TOTAL DAILY PURCHASE</div>
//             <div style={{ fontSize: "24px", fontWeight: "900" }}>{fmt(grandPurch)} <span style={{fontSize: "14px"}}>Qntl</span></div>
//           </div>
//           <div style={{ flex: 1, overflowY: "auto", padding: "10px" }}>
//             {pMills.map(m => <MillCard key={m.code} mill={m} type="purchase" />)}
//           </div>
//         </div>

//         {/* RIGHT COLUMN: SALE */}
//         <div style={{ flex: 1, display: "flex", flexDirection: "column", background: "#f1f5f9", borderRadius: "8px" }}>
//           <div style={{ background: "#065f46", color: "#fff", padding: "15px", borderRadius: "8px 8px 0 0" }}>
//             <div style={{ fontSize: "14px", fontWeight: "700", opacity: 0.9 }}>TOTAL DAILY SALE</div>
//             <div style={{ fontSize: "24px", fontWeight: "900" }}>
//                 Sold: {fmt(grandSold)} <span style={{fontSize: "14px"}}>Qntl</span>
//             </div>
//           </div>
//           <div style={{ flex: 1, overflowY: "auto", padding: "10px" }}>
//             {sMills.map(m => <MillCard key={m.code} mill={m} type="sale" />)}
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// }



















import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import * as XLSX from "xlsx";

const API_BASE = process.env.REACT_APP_API;

const fmt = (n) => {
  const num = parseFloat(n);
  if (isNaN(num)) return "0.00";
  return num.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const groupData = (rows) => {
  const mills = new Map();
  rows.forEach((r) => {
    const code = r.Mill_Code ?? "?";
    if (!mills.has(code)) {
      mills.set(code, { 
        code, 
        name: r.Short_Name || code, 
        rows: [], 
        totalQty: 0, 
        totalLot: 0, 
        totalSold: 0 
      });
    }
    const m = mills.get(code);
    m.rows.push(r);
    m.totalQty += Number(r.PurcQntl ?? r.Quantal ?? 0);
    m.totalLot += Number(r.LotSize ?? 0);
    m.totalSold += Number(r.Sold ?? 0);
  });
  return Array.from(mills.values()).sort((a, b) => a.name.localeCompare(b.name));
};

// --- Styles ---
const TH_STYLE = { 
  padding: "8px 10px", 
  fontSize: "13px", 
  color: "#475569", 
  textAlign: "left", 
  borderBottom: "2px solid #cbd5e1", 
  fontWeight: "800",
  textTransform: "uppercase",
  backgroundColor: "#f8fafc"
};

const TD_STYLE = { 
  padding: "8px 10px", 
  fontSize: "14px", 
  borderBottom: "1px solid #e2e8f0", 
  fontWeight: "600",
  color: "#1e293b"
};

const MillCard = ({ mill, type }) => (
  <div style={{
    background: "#fff",
    marginBottom: "8px", 
    border: "2px solid #cbd5e1",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    borderRadius: "4px"
  }}>
    <div style={{ 
      background: type === "purchase" ? "#dbeafe" : "#dcfce7", 
      padding: "10px 15px", 
      display: "flex", 
      justifyContent: "space-between", 
      borderBottom: "2px solid #cbd5e1" 
    }}>
      <span style={{ fontWeight: "900", fontSize: "16px", color: "#0f172a" }}>{mill.name}</span>
      <span style={{ fontSize: "14px", fontWeight: "900", color: "#1e293b" }}>
        {type === "purchase" 
          ? `Total: ${fmt(mill.totalQty)} Qntl` 
          : `Sold: ${fmt(mill.totalSold)} Qntl`}
      </span>
    </div>

    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr>
          <th style={{...TH_STYLE, textAlign: "left"}}>Grade</th>
          <th style={{...TH_STYLE, textAlign: "left"}}>DO No</th>
          <th style={{...TH_STYLE, textAlign: "left"}}>Season</th>
          <th style={{ ...TH_STYLE, textAlign: "right" }}>Mill Rate</th>
          <th style={{ ...TH_STYLE, textAlign: "right" }}>Purchase Rate</th>
          {type === "purchase" ? (
            <th style={{ ...TH_STYLE, textAlign: "right" }}>Quantity (Qntl)</th>
          ) : (
            <>
              <th style={{ ...TH_STYLE, textAlign: "right" }}>Lot (Qntl)</th>
              <th style={{ ...TH_STYLE, textAlign: "right" }}>Sold (Qntl)</th>
            </>
          )}
        </tr>
      </thead>
      <tbody>
        {mill.rows.map((r, i) => (
          <tr key={i}>
            <td style={{ ...TD_STYLE, textAlign: "left", fontFamily: "monospace" }}>{r.Grade || "—"}</td>
            <td style={{ ...TD_STYLE, textAlign: "left", fontFamily: "monospace" }}>{r.do || "—"}</td>
            <td style={{ ...TD_STYLE, textAlign: "left", fontFamily: "monospace" }}>{r.season || "—"}</td>
            <td style={{ ...TD_STYLE, textAlign: "right", fontFamily: "monospace" }}>{fmt(r.Mill_Rate)}</td>
            <td style={{ ...TD_STYLE, textAlign: "right", fontFamily: "monospace" }}>{fmt(r.Purc_Rate)}</td>
            {type === "purchase" ? (
              <td style={{ ...TD_STYLE, textAlign: "right", color: "#2563eb" }}>{fmt(r.PurcQntl || r.Quantal)}</td>
            ) : (
              <>
                <td style={{ ...TD_STYLE, textAlign: "right", color: "#64748b" }}>{fmt(r.LotSize)}</td>
                <td style={{ ...TD_STYLE, textAlign: "right", color: "#059669" }}>{fmt(r.Sold)}</td>
              </>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default function EnhancedReport({ toDate }) {
  const [data, setData] = useState({ pRows: [], sRows: [] });
  const [loading, setLoading] = useState(false);
  const companyCode = sessionStorage.getItem("Company_Code");
  const Company_Name = sessionStorage.getItem("Company_Name") || "Company";

  useEffect(() => {
    if (!toDate || !companyCode) return;
    setLoading(true);
    Promise.all([
      axios.get(`${API_BASE}/dailypurchase-report`, { params: { Company_Code: companyCode, Selected_Date: toDate } }),
      axios.get(`${API_BASE}/getallsauda`, { params: { Company_Code: companyCode, Selected_Date: toDate } }),
    ]).then(([p, s]) => {
      setData({ pRows: p.data.get_allTenders || [], sRows: s.data.get_live_tenders || [] });
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [toDate, companyCode]);

  const pMills = useMemo(() => groupData(data.pRows), [data.pRows]);
  const sMills = useMemo(() => groupData(data.sRows), [data.sRows]);

  const grandPurch = pMills.reduce((acc, m) => acc + m.totalQty, 0);
  const grandSold = sMills.reduce((acc, m) => acc + m.totalSold, 0);
  const grandLot = sMills.reduce((acc, m) => acc + m.totalLot, 0);

  // ── Export XLSX ──────────────────────────────────────────────────────────────
  const handleExportXLSX = () => {
    // Build Purchase Sheet Data
    const purchaseRows = [];
    purchaseRows.push(["PURCHASE REPORT"]);
    purchaseRows.push([`Date: ${toDate} | Company: ${Company_Name}`]);
    purchaseRows.push([]);
    purchaseRows.push(["Mill Name", "Grade", "DO No", "Season", "Mill Rate", "Purchase Rate", "Quantity (Qntl)"]);
    
    pMills.forEach(mill => {
      mill.rows.forEach(row => {
        purchaseRows.push([
          mill.name,
          row.Grade || "—",
          row.do || "—",
          row.season || "—",
          parseFloat(row.Mill_Rate) || 0,
          parseFloat(row.Purc_Rate) || 0,
          parseFloat(row.PurcQntl || row.Quantal) || 0
        ]);
      });
      purchaseRows.push([`TOTAL FOR ${mill.name}`, "", "", "", "", "", parseFloat(mill.totalQty)]);
      purchaseRows.push([]);
    });
    purchaseRows.push(["GRAND TOTAL PURCHASE", "", "", "", "", "", parseFloat(grandPurch)]);

    // Build Sale Sheet Data
    const saleRows = [];
    saleRows.push(["SALE REPORT"]);
    saleRows.push([`Date: ${toDate} | Company: ${Company_Name}`]);
    saleRows.push([]);
    saleRows.push(["Mill Name", "Grade", "DO No", "Season", "Mill Rate", "Purchase Rate", "Lot (Qntl)", "Sold (Qntl)"]);
    
    sMills.forEach(mill => {
      mill.rows.forEach(row => {
        saleRows.push([
          mill.name,
          row.Grade || "—",
          row.do || "—",
          row.season || "—",
          parseFloat(row.Mill_Rate) || 0,
          parseFloat(row.Purc_Rate) || 0,
          parseFloat(row.LotSize) || 0,
          parseFloat(row.Sold) || 0
        ]);
      });
      saleRows.push([`TOTAL FOR ${mill.name}`, "", "", "", "", "", parseFloat(mill.totalLot), parseFloat(mill.totalSold)]);
      saleRows.push([]);
    });
    saleRows.push(["GRAND TOTAL SALE", "", "", "", "", "", parseFloat(grandLot), parseFloat(grandSold)]);

    // Create Workbook
    const wb = XLSX.utils.book_new();
    const wsPurchase = XLSX.utils.aoa_to_sheet(purchaseRows);
    const wsSale = XLSX.utils.aoa_to_sheet(saleRows);
    
    // Set column widths
    wsPurchase["!cols"] = [{ wch: 25 }, { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 12 }, { wch: 14 }, { wch: 16 }];
    wsSale["!cols"] = [{ wch: 25 }, { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 12 }, { wch: 14 }, { wch: 12 }, { wch: 12 }];
    
    XLSX.utils.book_append_sheet(wb, wsPurchase, "Daily Purchase");
    XLSX.utils.book_append_sheet(wb, wsSale, "Daily Sale");
    XLSX.writeFile(wb, `DailyReport_${toDate}.xlsx`);
  };

  // ── Print ────────────────────────────────────────────────────────────────────
  const handlePrint = () => {
    const generateMillSection = (mill, type) => {
      const rows = mill.rows.map(row => `
        <tr>
          <td style="padding:6px 8px;border-bottom:1px solid #e2e8f0;">${row.Grade || "—"}</td>
          <td style="padding:6px 8px;border-bottom:1px solid #e2e8f0;">${row.do || "—"}</td>
          <td style="padding:6px 8px;border-bottom:1px solid #e2e8f0;">${row.season || "—"}</td>
          <td style="padding:6px 8px;border-bottom:1px solid #e2e8f0;text-align:right;">${fmt(row.Mill_Rate)}</td>
          <td style="padding:6px 8px;border-bottom:1px solid #e2e8f0;text-align:right;">${fmt(row.Purc_Rate)}</td>
          ${type === "purchase" 
            ? `<td style="padding:6px 8px;border-bottom:1px solid #e2e8f0;text-align:right;font-weight:700;">${fmt(row.PurcQntl || row.Quantal)}</td>`
            : `<td style="padding:6px 8px;border-bottom:1px solid #e2e8f0;text-align:right;">${fmt(row.LotSize)}</td>
               <td style="padding:6px 8px;border-bottom:1px solid #e2e8f0;text-align:right;font-weight:700;">${fmt(row.Sold)}</td>`
          }
        </tr>
      `).join("");

      return `
        <div style="margin-bottom:20px;border:1px solid #cbd5e1;border-radius:6px;break-inside:avoid;">
          <div style="background:${type === "purchase" ? "#dbeafe" : "#dcfce7"};padding:8px 12px;display:flex;justify-content:space-between;border-bottom:2px solid #cbd5e1;">
            <strong style="font-size:14px;">${mill.name}</strong>
            <span>${type === "purchase" ? `Total: ${fmt(mill.totalQty)} Qntl` : `Sold: ${fmt(mill.totalSold)} Qntl`}</span>
          </div>
          <table style="width:100%;border-collapse:collapse;">
            <thead>
              <tr style="background:#f8fafc;">
                <th style="padding:6px 8px;text-align:left;font-size:11px;">Grade</th>
                <th style="padding:6px 8px;text-align:left;font-size:11px;">DO No</th>
                <th style="padding:6px 8px;text-align:left;font-size:11px;">Season</th>
                <th style="padding:6px 8px;text-align:right;font-size:11px;">Mill Rate</th>
                <th style="padding:6px 8px;text-align:right;font-size:11px;">Purc Rate</th>
                ${type === "purchase" 
                  ? '<th style="padding:6px 8px;text-align:right;font-size:11px;">Qty (Qntl)</th>'
                  : '<th style="padding:6px 8px;text-align:right;font-size:11px;">Lot (Qntl)</th><th style="padding:6px 8px;text-align:right;font-size:11px;">Sold (Qntl)</th>'
                }
              </tr>
            </thead>
            <tbody>${rows}</tbody>
          </table>
        </div>
      `;
    };

    const purchaseSections = pMills.map(m => generateMillSection(m, "purchase")).join("");
    const saleSections = sMills.map(m => generateMillSection(m, "sale")).join("");

    const win = window.open("", "_blank", "width=1200,height=800");
    win.document.write(`
      <html>
        <head>
          <title>Daily Report - ${toDate}</title>
          <style>
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body { font-family: Arial, sans-serif; font-size: 12px; padding: 20px; background: #fff; }
            .header { text-align: center; margin-bottom: 20px; }
            .header h1 { font-size: 18px; margin-bottom: 4px; }
            .header h3 { font-size: 14px; font-weight: normal; color: #555; }
            .section-title { font-size: 16px; font-weight: bold; margin: 20px 0 10px; padding-bottom: 6px; border-bottom: 2px solid #333; }
            .totals { display: flex; gap: 20px; justify-content: center; margin: 15px 0; }
            .total-box { padding: 8px 20px; border-radius: 8px; text-align: center; }
            .total-box.purchase { background: #dbeafe; }
            .total-box.sale { background: #dcfce7; }
            .total-box .label { font-size: 11px; font-weight: bold; text-transform: uppercase; }
            .total-box .value { font-size: 18px; font-weight: bold; }
            @media print {
              body { padding: 10px; }
              .no-print { display: none; }
              .total-box { border: 1px solid #ccc; }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>${Company_Name}</h1>
            <h3>Daily Purchase & Sale Report</h3>
            <h3>Date: ${toDate}</h3>
          </div>
          
          <div class="totals">
            <div class="total-box purchase">
              <div class="label">TOTAL PURCHASE</div>
              <div class="value">${fmt(grandPurch)} Qntl</div>
            </div>
            <div class="total-box sale">
              <div class="label">TOTAL SALE</div>
              <div class="value">${fmt(grandSold)} Qntl</div>
            </div>
          </div>

          <div class="section-title">📥 PURCHASE DETAILS</div>
          ${purchaseSections || "<p>No purchase data available.</p>"}
          
          <div class="section-title" style="margin-top:30px;">📤 SALE DETAILS</div>
          ${saleSections || "<p>No sale data available.</p>"}
          
          <div style="text-align:center; margin-top:30px; font-size:10px; color:#999;">
            Generated on ${new Date().toLocaleString()}
          </div>
        </body>
      </html>
    `);
    win.document.close();
    setTimeout(() => win.print(), 300);
  };

  if (loading) return <div style={{ padding: "40px", fontSize: "20px", fontWeight: "bold" }}>Loading Report Data...</div>;

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: "#cbd5e1" }}>
      
      {/* Header with Export Buttons */}
      <div style={{ 
        background: "#fff", 
        padding: "10px 16px", 
        display: "flex", 
        justifyContent: "flex-end", 
        gap: "10px",
        borderBottom: "1px solid #cbd5e1",
        flexShrink: 0
      }}>
        <button
          onClick={handleExportXLSX}
          disabled={loading || (pMills.length === 0 && sMills.length === 0)}
          style={{
            padding: "8px 18px",
            borderRadius: "6px",
            border: "none",
            background: "#22c55e",
            color: "#fff",
            fontWeight: "700",
            fontSize: "13px",
            cursor: "pointer",
            opacity: (loading || (pMills.length === 0 && sMills.length === 0)) ? 0.5 : 1
          }}
        >
          ⬇ Export XLSX
        </button>
        <button
          onClick={handlePrint}
          disabled={loading || (pMills.length === 0 && sMills.length === 0)}
          style={{
            padding: "8px 18px",
            borderRadius: "6px",
            border: "none",
            background: "#64748b",
            color: "#fff",
            fontWeight: "700",
            fontSize: "13px",
            cursor: "pointer",
            opacity: (loading || (pMills.length === 0 && sMills.length === 0)) ? 0.5 : 1
          }}
        >
          🖨 Print
        </button>
      </div>

      {/* Side-by-Side Columns */}
      <div style={{ display: "flex", flex: 1, gap: "5px", overflow: "hidden", padding: "5px" }}>
        
        {/* LEFT COLUMN: PURCHASE */}
        <div style={{ flex: 1, display: "flex", flexDirection: "column", background: "#f1f5f9", borderRadius: "8px" }}>
          <div style={{ background: "#1e3a8a", color: "#fff", padding: "15px", borderRadius: "8px 8px 0 0" }}>
            <div style={{ fontSize: "14px", fontWeight: "700", opacity: 0.9 }}>TOTAL DAILY PURCHASE</div>
            <div style={{ fontSize: "24px", fontWeight: "900" }}>{fmt(grandPurch)} <span style={{fontSize: "14px"}}>Qntl</span></div>
          </div>
          <div style={{ flex: 1, overflowY: "auto", padding: "10px" }}>
            {pMills.length === 0 ? (
              <div style={{ textAlign: "center", padding: "40px", color: "#64748b" }}>No purchase data available</div>
            ) : (
              pMills.map(m => <MillCard key={m.code} mill={m} type="purchase" />)
            )}
          </div>
        </div>

        {/* RIGHT COLUMN: SALE */}
        <div style={{ flex: 1, display: "flex", flexDirection: "column", background: "#f1f5f9", borderRadius: "8px" }}>
          <div style={{ background: "#065f46", color: "#fff", padding: "15px", borderRadius: "8px 8px 0 0" }}>
            <div style={{ fontSize: "14px", fontWeight: "700", opacity: 0.9 }}>TOTAL DAILY SALE</div>
            <div style={{ fontSize: "24px", fontWeight: "900" }}>
                Sold: {fmt(grandSold)} <span style={{fontSize: "14px"}}>Qntl</span>
            </div>
          </div>
          <div style={{ flex: 1, overflowY: "auto", padding: "10px" }}>
            {sMills.length === 0 ? (
              <div style={{ textAlign: "center", padding: "40px", color: "#64748b" }}>No sale data available</div>
            ) : (
              sMills.map(m => <MillCard key={m.code} mill={m} type="sale" />)
            )}
          </div>
        </div>

      </div>
    </div>
  );
}